import { DepthChartPlayer, Side } from "../../../types/DepthChartTypes";
import { RosterPlayer } from "../../../types/RosterTypes";

const getPosition = (rosterPlayer: RosterPlayer, selectedSide: Side): string => {
  let position = "";
  if (selectedSide === "OFFENSE") {
    position = rosterPlayer.player.offensive_position || "";
  } else if (selectedSide === "DEFENSE") {
    position = rosterPlayer.player.defensive_position || "";
  } else {
    position = `${rosterPlayer.player.offensive_position} / ${rosterPlayer.player.defensive_position}`;
  }
  return position;
}

// Transform roster players into a format for the player list
export const transformRosterPlayersToList = (rosterPlayers: RosterPlayer[], selectedSide: Side): DepthChartPlayer[] => {
  return rosterPlayers.map((rosterPlayer: RosterPlayer) => {
    return {
      id: rosterPlayer.player.id,
      name: rosterPlayer.player.name,
      roster_membership_id: rosterPlayer.id,
      jersey_number: rosterPlayer.jersey_number,
      status: rosterPlayer.status,
      position: getPosition(rosterPlayer, selectedSide),
      position_group: rosterPlayer.player.position_group,
      player: {
        id: rosterPlayer.player.id,
        name: rosterPlayer.player.name,
        offensive_position: rosterPlayer.player.offensive_position,
        defensive_position: rosterPlayer.player.defensive_position,
        position_group: rosterPlayer.player.position_group,
      }
    };
  });
};


// Check if player drop is in a valid position
export const isValidPositionDrop = (
  positionId: string, 
  playerId: number, 
  existingPlayers: DepthChartPlayer[],
  allPositions: Record<string, DepthChartPlayer[]>,
  targetDepth: number
): boolean => {
  // If no existing players, it's valid
  if (!existingPlayers || existingPlayers.length === 0) {
    return true;
  }

  // Check if player is already in this specific position
  const playerExistsInPosition = existingPlayers.some((p) => p && p.id === playerId);
  if (playerExistsInPosition) {
    return false; // Don't allow duplicates within the same position
  }

  // If trying to add as a starter (depth 1), check if they're a starter elsewhere
  if (targetDepth === 1) {
    // Check all positions to see if the player is a starter anywhere
    for (const [currentPositionId, players] of Object.entries(allPositions)) {
      if (currentPositionId !== positionId && players.length > 0 && players[0]?.id === playerId) {
        return false; // Player is already a starter in another position
      }
    }
  }

  return true;
};

export const createDepthSlots = (players: DepthChartPlayer[], maxDepth: number) => {
  return Array(maxDepth)
    .fill(null)
    .map((_, index) => {
      return players[index] || null;
    });
};
